import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './App.css';

// Lazy load components for better performance
const HomePage = lazy(() => import('./components/HomePage'));
const SEOGeoAnalyzer = lazy(() => import('./components/SEOGeoAnalyzer'));
const AISearchAnalyzer = lazy(() => import('./components/AISearchAnalyzer'));

// Loading component for Suspense fallback
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
    <span className="ml-3 text-lg">Loading...</span>
  </div>
);

function App() {
  return (
    <Router>
    <div className="App">
      <Toaster position="top-right" />
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/seo-geo-analyzer" element={<SEOGeoAnalyzer />} />
            <Route path="/ai-ranking-tracker" element={<AISearchAnalyzer />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App; 